// import http from "src/utils/axios";

import { http } from "src/utils/http";

export const loginWithPasswordApi = async (request) =>
  http.post("/v1/partners/login/password", request, false);

export const refreshTokenApi = async (request) =>
  http.post("/v1/users/token", request, false);

export const fetchProfileApi = async () => http.get("/v1/users/info");

export const fetchBankApi = async () => http.get("/v1/verify/bank");

export const fetchImageApi = async (path) =>
  http.get(`/v1/manager/images?path=${path}`);

export const fetchProfileByIdApi = async (id = "") =>
  http.get(`/v1/manager/users/profile/${id}`);

export const depositConfirmApi = async (request) =>
  http.post("/v1/manager/deposit/confirm", request);

export const withdrawConfirmApi = async (request) =>
  http.post("/v1/manager/withdrawal/confirm", request);

export const personalConfirmApi = async (request) =>
  http.post("/v1/manager/verify/personal/confirm", request);

export const bankConfirmApi = async (request) =>
  http.post("/v1/manager/verify/bank/confirm", request);

export const affiliateApi = async (request) =>
  http.get("/v1/affiliate/domain", request);

export const createDomainAffiliateApi = async (request) =>
  http.post("/v1/affiliate/domain", request);

export const referralApi = async ({ value, draw, start, length }) =>
  http.get(
    `/v1/partners/referral?draw=${draw}&columns[0][data]=createdAt&columns[0][name]=s_created_at&columns[0][searchable]=true&columns[0][orderable]=true&columns[0][search][value]=&columns[0][search][regex]=false&columns[1][data]=username&columns[1][name]=username&columns[1][searchable]=true&columns[1][orderable]=true&columns[1][search][value]=${
      value ? value : ``
    }&columns[1][search][regex]=false&columns[2][data]=&columns[2][name]=user.&columns[2][searchable]=true&columns[2][orderable]=true&columns[2][search][value]=&columns[2][search][regex]=false&columns[3][data]=totalCommission&columns[3][name]=total_commission&columns[3][searchable]=false&columns[3][orderable]=true&columns[3][search][value]=&columns[3][search][regex]=false&order[0][column]=1&order[0][dir]=desc&start=${
      start ? start : 0
    }&length=${
      length ? length : 10
    }&search[value]=&search[regex]=false&_=1702267844975`
  );

export const commissionApi = async ({ value, draw, start, length }) =>
  http.get(
    `/v1/partners/commission/json-data?draw=${draw ?? 1}&columns[0][data]=createdAt&columns[0][name]=s_created_at&columns[0][searchable]=true&columns[0][orderable]=true&columns[0][search][value]=&columns[0][search][regex]=false&columns[1][data]=user.id&columns[1][name]=user._id&columns[1][searchable]=true&columns[1][orderable]=true&columns[1][search][value]=&columns[1][search][regex]=false&columns[2][data]=user.username&columns[2][name]=user.username&columns[2][searchable]=true&columns[2][orderable]=true&columns[2][search][value]=&columns[2][search][regex]=false&columns[3][data]=positionNo&columns[3][name]=history_position.position_no&columns[3][searchable]=true&columns[3][orderable]=true&columns[3][search][value]=&columns[3][search][regex]=false&columns[4][data]=instrument.symbol&columns[4][name]=instrument.symbol&columns[4][searchable]=true&columns[4][orderable]=true&columns[4][search][value]=&columns[4][search][regex]=false&columns[5][data]=units&columns[5][name]=s_units&columns[5][searchable]=true&columns[5][orderable]=true&columns[5][search][value]=&columns[5][search][regex]=false&columns[6][data]=overnightFeeCommission&columns[6][name]=overnight_fee_commission&columns[6][searchable]=true&columns[6][orderable]=true&columns[6][search][value]=&columns[6][search][regex]=false&columns[7][data]=spreadCommission&columns[7][name]=total_commission&columns[7][searchable]=true&columns[7][orderable]=true&columns[7][search][value]=&columns[7][search][regex]=false&order[0][column]=0&order[0][dir]=desc&start=${
      start ? start : 0
    }&length=${
      length ? length : 100
    }&search[value]=&search[regex]=false&_=1702355651457`
  );
